export default __webpack_public_path__ + "static/media/Michael Gates.18603975.jpg";